import { useQuery } from '@tanstack/react-query';

import ProductsService from '@/services/ProductsService';

export const RECOMMENDATION_PRODUCTS_QUERY_KEY = (productId: string) => [
  'recommendationProducts',
  productId,
];

export function useRecommendationProducts(productId: string) {
  const { data, isFetching } = useQuery({
    queryKey: RECOMMENDATION_PRODUCTS_QUERY_KEY(productId),
    queryFn: () => ProductsService.recommendationProducts(productId),
  });

  return {
    recommendation: data,
    isLoading: isFetching,
  };
}
